module.exports = __webpack_public_path__ + "img/title_uk.b00dac25.svg";